module.exports = __webpack_public_path__ + "static/media/close-icon.cb8b4612.svg";